import { useEffect, useState } from "react";
import { Alert, Badge, Button, Card, Col, Container, FloatingLabel, Form, Image, InputGroup, Row, Spinner } from "react-bootstrap";
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import DB from "../services/firestoredb";
import GooglePayButton from '@google-pay/button-react';
//import ApplePay, { STATUS_SUCCESS, STATUS_FAILURE } from 'apple-pay';
import PayHeader from "../layout/payheader";
import PayFooter from "../layout/payfooter";
import LatPayBrand from "./brand";
import LPAPI from "../services/paylink";
import utils from "../utils/utils";
import { onMessageListener } from "../firebase-config";
import { Toast } from "react-bootstrap";
import { faCheck, faCircleCheck, faHourglass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import latpayUrl from "../config";

import latpayDomain from "../config";
import { STATUS_FAILURE, STATUS_SUCCESS } from "apple-pay";

//const iscard=false;

var session = null;
const shippingOption = "";
var transKey = "";

const POSPay = () => {
    const navigate = useNavigate();
    const params = useParams();
    const merchantId = params.client || "none";
    const trxId = params.id || "none";
    const [merchInfo, setMerchInfo] = useState();
    const [trx, setTrx] = useState();
    const [invalid, setInvalid] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [showOrder, setShowOrder] = useState(false);
    const [invalidTrx, setInvalidTrx] = useState(false);
    const [brand, setBrand] = useState();
    const [cardInfo, setCardInfo] = useState({
        name: "",
        card: "",
        exp: "",
        cvc: "",
    });
    const [searchParams] = useSearchParams();
    const demoResult = searchParams.get("result");

    const [show, setShow] = useState(false);
    const [notification, setNotification] = useState({ title: '', body: '' });

    const [custIndividualEmail, setCustIndividualEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    var trxStream;

    var runningAmount;
    // const ApplepayMerchantId = "merchant.btrut";//latpay.applepay";
    const ApplepayMerchantId = "latpay.applepay";
    const ApplepayMerchantDisplay = "Latpay";
    const ApplepayUrl = `https://${latpayUrl}/api`;

    onMessageListener().then(payload => {
        //console.log("this is in pay.jsx");
        //console.log(payload);
        const loc = payload.data?.loc;

        const t = { ...trx };

        for (const item of (trx.order || [])) {
            if (item.info?.loc === loc) {
                item.order.status = "done";
            }
        }
        let c = 0;
        for (const item of (trx.order || [])) {
            if (item.order.status !== "done") {
                c++;
            }
        }
        if (c === 0) {
            t.status = "completed";
        }
        setTrx(t);

        setShow(true);
        setNotification({ title: payload.notification.title, body: payload.notification.body })

    }).catch(err => console.log('failed: ', err));

    const listenToStream = (trx) => {
        if (trxStream) {
            try {
                // unsubscribe somehow?
                // it's an onSnapshot response
            } catch (e) { }
        }
        trxStream = DB.POSTrxStream(merchantId, trx.id,
            (snapshot) => {
                const tx = snapshot.data();
                // console.log(tx);
                setTrx(tx);
            },
            (error) => { },
        );
    }

    //const gtoken = '{"signature":"MEUCIQCJuEh5Fdd/st8Mydt8vc6SEoMmo1nnnbs/X50+BwFTfAIgCHvp+b0X92VwO0pas39R3wbB+ctMm1gEKkX7wZ/kNgM\u003d","protocolVersion":"ECv1","signedMessage":"{\"encryptedMessage\":\"FHRNSvdAPwthmbv0b0HudCA3doaAcVoECyhDtLoXY4k0b4eu2yP4HeDv2yzu6s3MePKDrVgTXgO7ghSdDiNoVhIBrsYVbf3MCgJdSm9bt9Y2ku4lCj+AuOaSvQ3CjB2g68mCQNpVjR14W7s8MWHYYTAfa1kmd3pLUFqKXzmnq6OE6zeSQXBIDQ+/TO5Ya2Uv/pHmcgtX02d1zGegdIXFvdEaqmfMk880FeYZBrzbK9mq0pvuNRDnrbxIesr1qOSco5OA/IpkTxaA61teU9shvQfUbKjfo8MwiHs4evkOx7HGREhS2j4d6xntixq2RMWRDNal7/vOyVdBYQQ3egdgyGTEeF5W5rzRUEp0xZM07qMVuAuiQwgsLYVTb9j/HMy4VrhSt9AnpADE4sNROxv0kBeMPnofKyfzPAtjKwfWVGtg5hINH/E0xuqDikz6e1RNhqYWAe+9E1yLyg\\u003d\\u003d\",\"ephemeralPublicKey\":\"BA+ixxF6vHJOo+g0aC0wMgvYAwD7mm/0EEbupR1/ggLTWZrRLzwlYd7hKHUbFqSRRIrouI+hI4ObWWi4EtiMx2o\\u003d\",\"tag\":\"CK74k26ixZuR991g+TAIQ+529LyhtTjTi2RNxky+E/s\\u003d\"}"}';
    const billingAddressParameters = {
        phoneNumberRequired: false
    };

    const googlePayInfo = (trx) => {


        return {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
                {
                    type: 'CARD',
                    parameters: {
                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                        allowedCardNetworks: ['AMEX', 'DISCOVER', 'JCB', "INTERAC", 'MASTERCARD', 'VISA'],
                        assuranceDetailsRequired: true,
                        billingAddressParameters: billingAddressParameters,
                    },
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                            gateway: 'cybersource',
                            gatewayMerchantId: 'gpaulpy37642822',
                        },
                    },
                },
            ],
            merchantInfo: {
                merchantId: 'BCR2DN6T6P3OZHZ2',
                merchantName: 'Latpay',
            },
            transactionInfo: {
                totalPriceStatus: 'FINAL',
                totalPriceLabel: 'Total',
                totalPrice: trx.amount.toFixed(2),
                currencyCode: trx.currency,
                countryCode: trx.countryCode || 'AU',
            },

            shippingAddressRequired: true,
            emailRequired: true,
        };
    }

    var shippingOption = "";
    var shippingCost = 0;
    var errorMsg = null;
    var merchantIdentifier = "";
    var session = null;



    var runningPP = 0;
    const getShippingCosts = (shippingIdentifier, updateRunningPP) => {

        switch (shippingIdentifier) {
            case 'domestic_std':
                shippingCost = 0;
                break;
            case 'domestic_exp':
                shippingCost = 0;
                break;
            case 'international':
                shippingCost = 0;
                break;
            default:
                shippingCost = 0;
        }

        if (updateRunningPP == true) {
            runningPP = shippingCost;
        }

        return shippingCost;

    }

    getShippingCosts('domestic_std', true);
    var runningTotal = () => { return runningAmount + runningPP; }








    const payWithApple = async () => {
        if (window.ApplePaySession) {

            merchantIdentifier = 'merchant.latpay.applepay';
            //  merchantIdentifier = document.getElementById("ApplepayMerchantId").value;
            var promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            promise.then((canMakePayments) => {
                if (canMakePayments) {

                    //  document.getElementById("applepayButtonId").style.display = "block";
                } else {
                    //log("ApplePay is possible on this browser, but not currently activated.");
                }
            });

        } else {
            //log("ApplePay is not available on this browser.");
        }
        var paymentRequest = {
            currencyCode: 'AUD',
            countryCode: 'AU',
            //requiredShippingContactFields: ['postalAddress'],
            //requiredShippingContactFields: ['postalAddress', 'email', 'name', 'phone'],
            requiredShippingContactFields: ['postalAddress', 'email', 'name'],
            //  requiredBillingContactFields: ['postalAddress','email', 'name'],
            // lineItems: [{ label: subTotalDescr, amount: runningAmount }, { label: 'P&P', amount: runningPP }],
            lineItems: [],
            total: {
                label: 'Total',
                amount: runningTotal()
            },
            supportedNetworks: ['amex', 'masterCard', 'visa'],
            //merchantCapabilities: ['supports3DS', 'supportsEMV', 'supportsCredit', 'supportsDebit']
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit']
        };

        session = new window.ApplePaySession(1, paymentRequest)

        // console.log("Ready to go");
        var request = {
            currency: "AUD",
            //amount: trx.amount,
            amount: trx.amount.toFixed(2),
            // reference: trx.id,
            tRef: trx.id,
            reference: (trx.clientRef !== undefined && trx.clientRef !== null && trx.clientRef !== "") ? trx.clientRef : trx.id,
            description: trx.description,
            publickey: trx.testMode ? merchInfo.test.paylinkPWD : merchInfo.live.paylinkPWD,
            merchantid: trx.testMode ? merchInfo.test.paylinkMID : merchInfo.live.paylinkMID,
            transid: "0",
            source: "PayLink",
            otgMerchant: merchantId,
            transactionkey: transKey
        };
        //console.log(JSON.stringify(request));
        Applepay.PaymentProcess(request);

    }


    const Applepay = {
        PaymentProcess: (key) => {
            //console.log('');
            validate(key).then((result) => {
                if (result) {
                    console.log("validate success");
                    // Merchant Validation
                    session.onvalidatemerchant = (event) => {

                        var promise = performValidation(event.validationURL, key.merchantid, key.currency);

                        promise.then((merchantSession) => {

                            try {
                                //console.log("MerchantSession : " + JSON.stringify(merchantSession));
                                session.completeMerchantValidation(JSON.parse(merchantSession));
                            }
                            catch (err) {
                                console.log(err);
                                console.log("Merchant validation exception.");
                            }
                        });
                    }
                    session.onshippingcontactselected = (event) => {
                        console.log("shippingcontact selected");
                        getShippingOptions(event.shippingContact.countryCode);

                        var status = window.ApplePaySession.STATUS_SUCCESS;
                        var newShippingMethods = shippingOption;
                        var newTotal = { type: 'final', label: 'Latpay', amount: runningTotal() };
                        //var newLineItems = [{ type: 'final', label: subTotalDescr, amount: runningAmount }, { type: 'final', label: 'P&P', amount: runningPP }];
                        var newLineItems = [];

                        session.completeShippingContactSelection(status, newShippingMethods, newTotal, newLineItems);


                    }
                    session.onshippingmethodselected = (event) => {
                        console.log("shipping method selected");
                        getShippingCosts(event.shippingMethod.identifier, true);

                        var status = window.ApplePaySession.STATUS_SUCCESS;
                        var newTotal = { type: 'final', label: 'Latpay', amount: runningTotal() };
                        // var newLineItems = [{ type: 'final', label: subTotalDescr, amount: runningAmount }, { type: 'final', label: 'P&P', amount: runningPP }];
                        var newLineItems = [];
                        session.completeShippingMethodSelection(status, newTotal, newLineItems);

                    }
                    session.onpaymentmethodselected = (event) => {
                        console.log("paymentmethod selected");
                        var newTotal = { type: 'final', label: 'Latpay', amount: runningTotal() };
                        // var newLineItems = [{ type: 'final', label: subTotalDescr, amount: runningAmount }, { type: 'final', label: 'P&P', amount: runningPP }];
                        var newLineItems = [];
                        session.completePaymentMethodSelection(newTotal, newLineItems);


                    }
                    session.onpaymentauthorized = (event) => {
                        if (event.payment.token.paymentData != null) {
                            console.log("paymentauthorized");
                            // console.log(`The key.amount is : ${key.amount}`);
                            // console.log(`The key.amount is : ${key.amount.toFixed(2)}`);
                            //console.log(JSON.stringify(event.payment));
                            var requestData = {
                                paymentData: event.payment.token.paymentData,
                                paymentMethod: event.payment.token.paymentMethod,
                                currency: key.currency,
                                amount: key.amount,
                                //amount: key.amount.toFixed(2),
                                tRef: key.tRef,
                                reference: key.reference,
                                description: key.description,
                                publickey: key.publickey,
                                merchantid: key.merchantid,
                                transid: key.transid,
                                source: key.source,
                                otgMerchant: merchantId,
                                wallet: "apple",
                                transactionkey: transKey,
                                shippingAddress: event.payment.shippingContact != null ? event.payment.shippingContact : null,
                                email: event.payment.shippingContact != null ? event.payment.shippingContact.emailAddress : null,
                            }
                            //console.log("requestData:" + JSON.stringify(requestData));
                            // const dataSends = {
                            //     msg: JSON.stringify(requestData),
                            // }
                            // sentEmail(dataSends);
                            sendPaymentProcess(requestData).then(async (paymentResponse) => {
                                var status;
                                // console.log(paymentResponse);
                                // const dataSend = {
                                //     msg: JSON.parse(paymentResponse),
                                // }
                                // sentEmail(dataSend);
                                if (paymentResponse != null) {
                                    var result = paymentResponse;

                                    if (result.status.statuscode == "0") {
                                        status = window.ApplePaySession.STATUS_SUCCESS;
                                        session.completePayment(status);
                                        const t = { ...trx };
                                        t.status = "success";
                                        t.transactionid = result.transactionid;
                                        t.code = result.code;
                                        //t.code = JSON.stringify(result);
                                        setTrx(t);
                                        // sentEmail1(JSON.stringify(result));
                                        // const dataSend = {
                                        //     msg: JSON.stringify(result),
                                        // };
                                        // sentEmail(dataSend);

                                        if (result.redirect) {
                                            setTimeout(() => {
                                                window.location.href = result.redirect;
                                            }, 1000);
                                        } else {
                                            //console.log("subscribing to stream");
                                            //const strm = DB.POSTrxStream(merchantId,trxId);
                                        }
                                        if (trx.trxRef !== "POS" && trx.trxRef !== "QR") {
                                            let infos;
                                            try {
                                                infos = await DB.getPOSMerchInfo(merchantId, trxId);
                                            } catch (e) {
                                                alert(e.message);
                                            }

                                            const date = new Date();
                                            const EmailReceipt = {
                                                //amount: trx.amount,
                                                amount: trx.amount.toFixed(2),
                                                currency: trx.currency,
                                                transactiondate: date.getUTCDate() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCFullYear(),
                                                transactionid: result.authresponse.gatewayreference,
                                                banktransactionnumber: result.authresponse.banktransactionno,
                                                cardno: requestData.paymentMethod.displayName,
                                                // customername:result.consumer.firstname.trim()+result.consumer.lastname.trim(),
                                                // customeremail:result.consumer.email,
                                                customername: infos.plName,
                                                customeremail: infos.mail,
                                                merchantemail: infos.plMerchantEmail,
                                                merchantId: infos.merchantId,
                                                gatewayreference: ""
                                            }
                                            sentEmailReceipt(EmailReceipt);
                                        } else {
                                            console.log("It's not a Paylink Transaction");
                                            let infos;
                                            try {
                                                infos = await DB.getPOSMailInfo(merchantId);
                                            } catch (e) {
                                                // alert(e.message);
                                                console.error(`Error here: ${e.message}`);
                                            }

                                            const date = new Date();
                                            const EmailReceipt = {
                                                //amount: trx.amount,
                                                amount: trx.amount.toFixed(2),
                                                currency: trx.currency,
                                                transactiondate: date.getUTCDate() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCFullYear(),
                                                transactionid: result.authresponse.gatewayreference,
                                                banktransactionnumber: result.authresponse.banktransactionno,
                                                cardno: requestData.paymentMethod.displayName,
                                                customername: requestData.shippingAddress.givenName,
                                                customeremail: requestData.email,
                                                merchantemail: infos,
                                                merchantId: merchantId,
                                                gatewayreference: ""
                                            }
                                            sentEmailReceipt(EmailReceipt);
                                        }
                                        /*
                                        const date = new Date();
                                        const EmailReceipt = {
                                            amount: trx.amount,
                                            currency: trx.currency,
                                            transactiondate: date.getUTCDate() + "-" + date.getUTCMonth() + "-" + date.getUTCFullYear(),
                                            transactionid: result.authresponse.gatewayreference,
                                            banktransactionnumber: result.authresponse.banktransactionno,
                                            cardno:requestData.paymentMethod.displayName,
                                            customeremail:requestData.email,
                                            customername:requestData.shippingAddress.givenName
                                        }
                                        sentEmailReceipt(EmailReceipt);
                                        */
                                        listenToStream(t);
                                    } else {
                                        status = window.ApplePaySession.STATUS_FAILURE;
                                        errorMsg = Applepay.messages.failed;
                                        //console.log(errorMsg);
                                        const t = { ...trx };
                                        t.status = "error";
                                        try {
                                            t.errorMsg = result.status.errordesc;
                                        } catch (e) {
                                            t.errorMsg = null;
                                        }
                                        setTrx(t);
                                        //if (key.source == "ApplePay")
                                        //  window.location.href = Url + 'DigitalWallet/ResultPage?request=' + JSON.stringify(result) + '';
                                    }
                                }
                                session.completePayment(status);
                            }).catch((err) => {
                                console.log("Load payment data exception.");
                                console.log(err);
                            })
                        }
                        else {
                            console.log("Payment Authorization failed.");
                        }
                    }
                    session.oncancel = (event) => {
                        errorMsg = Applepay.messages.cancelled + ":" + event;
                        //console.log(event);
                        console.log(errorMsg);
                    }
                    session.begin();
                }
                else {
                    console.log("Key Validation Failed.");
                }
            }).catch((err) => {
                console.log("Payment Request exception.");
                console.log(err);
            });
        },
        CancellPayment: (key) => {
            errorMsg = Applepay.messages.cancelled;
            console.log(errorMsg);
        },
        messages: {
            required: "This field is required.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            failed: 'Transaction Declined.Please try again..',
            cancelled: 'Payment Cancelled.'
        }
    }

    const sendPaymentProcess = async (requestData) => {
        var token = JSON.stringify(requestData.paymentData);
        var rData = JSON.stringify(requestData);
        //console.log("Token:" + token);
        //Base 64 encoded
        var enc = window.btoa(token);
        //console.log("Base 64:" + enc);

        var processUrl = `https://${latpayDomain}/api/wallet`;
        try {
            const response = await fetch(
                processUrl,
                {
                    method: 'POST',
                    body: rData,
                    headers: { 'Content-Type': 'application/json', }
                }
            );
            const result = await response.json();
            //console.log(result);
            if (result.status.statuscode == "0") {
                // console.log(result.status.errordesc);


            }
            else {
                // console.log(result.status.errordesc);
                // console.log("else part");
            }
            return result;
        }
        catch (e) {

            console.log(e.message);
            return;
        }
    }

    /*
    const sendPaymentProcess=async(requestData)=> {
        var token = JSON.stringify(requestData.paymentData);
        console.log("Token:" + token);
        //Base 64 encoded
        var enc = window.btoa(token);
        console.log("Base 64:" + enc);
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            var processUrl = `https://${latpayDomain}/api/wallet`
            xhr.open('POST', processUrl);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(requestData));
            xhr.onload =  ()=> {
                console.log("Payment Response:"+this.response);

                const dataSending = {
                    msg: JSON.stringify(this.response),
                }
                sentEmail(dataSending);

                var result = JSON.parse(this.response);

                if (result.status.statuscode != "0")
                    console.log(result.status.errordesc);
                resolve(this.response);
            };
            xhr.onerror = function () {
                //console.log(errorThrown);
                console.log("Payment Response Failed. ");
                reject(null);
            };
        });
        }
        */

    /*
    const sendPaymentProcess = async (requestData) => {
        var token = JSON.stringify(requestData.paymentData);
        var rData = JSON.stringify(requestData);
        console.log("Token:" + token);
        //Base 64 encoded
        var enc = window.btoa(token);
        console.log("Base 64:" + enc);

        var processUrl = `https://${latpayDomain}/api/wallet`;
        try {
            const response = await fetch(
                processUrl,
                {
                    method: 'POST',
                    body: rData,
                    headers: { 'Content-Type': 'application/json', }
                }
            );
            const result = await response.json();
            console.log(result);
            if (result.status.statuscode == "0") {
                console.log(result.status.errordesc);


            }
            else {
                console.log(result.status.errordesc);
                console.log("else part");
            }
            return result;
        }
        catch (e) {

            console.log(e.message);
            return;
        }
    }
    */



    const getShippingOptions = (shippingCountry) => {
        // console.log("getshippingOptions");
        if (shippingCountry.toUpperCase() == "AU") {
            shippingOption = [{ label: 'Standard Shipping', amount: getShippingCosts('domestic_std', true), detail: '3-5 days', identifier: 'domestic_std' }, { label: 'Expedited Shipping', amount: getShippingCosts('domestic_exp', false), detail: '1-3 days', identifier: 'domestic_exp' }];
        } else {
            shippingOption = [{ label: 'International Shipping', amount: getShippingCosts('international', true), detail: '5-10 days', identifier: 'international' }];
        }
    }

    const performValidation = (valURL, merchantid, currency) => {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var data = JSON.parse(this.responseText);
                //console.log("Server Response \n" + this.responseText);
                resolve(data);
            };
            xhr.onerror = reject;
            xhr.open('POST', 'https://www.lateralpayments.com/checkout-staging/wallet/applepay_validate?valURL=' + valURL + '&&merchantId=' + merchantid + '&&currency=' + currency + '&&domainName=latpay.net');
            //  xhr.open('POST', 'https://www.lateralpayments.com/checkout-staging/wallet/applepay_validate?valURL=https://apple-pay-gateway.apple.com/paymentservices/startSession&&merchantId=test_GP_Live&&currency=AUD&&domainName=latpay.net');
            xhr.send();
        });
    }

    const validate = async (key) => {

        const json = JSON.stringify(key);

        const url = `https://www.lateralpayments.com/checkout-staging/wallet/applepayauthorise`;
        //console.log(`apay_validate url: ${url}`);
        try {
            const response = await fetch(
                url,
                {
                    method: 'POST',
                    body: json,
                    headers: { 'Content-Type': 'application/json', }
                }
            );
            const result = await response.json();
            //console.log(result);
            if (result.status.statuscode == "0") {
                // resolve(true);
                // console.log(result.status.errordesc);
                return true;
            }
            else {
                return false;
                // resolve(false);
            }
            //  return result;
        }
        catch (e) {

            console.log(e.message);
            return false;
            // return {"error":e.message };
        }
        // });       
    }

    /*
    const handleChange = (e) => {
        const c = { ...cardInfo };
        c[e.target.name] = e.target.value;
        setCardInfo(c);
    }
    */

    const handleChange = (e) => {
        if (e.target.name === 'email') {
            setCustIndividualEmail(e.target.value);
            validateEmail(e.target.value);
        } else {
            const c = { ...cardInfo };
            c[e.target.name] = e.target.value;
            setCardInfo(c);
        }
    };

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        setEmailError(re.test(email) ? '' : 'Invalid email');
    };


    const timeout = (delay) => {
        return new Promise(res => setTimeout(res, delay));
    }

    const tryAgain = () => {

        //Clearing All card details.
        cardInfo.name = "";
        cardInfo.exp = "";
        cardInfo.cvc = "";
        cardInfo.card = "";

        setProcessing(false);
        const t = {
            ...trx,
            "status": "new",
        };
        setTrx(t);
    }

    const payBtnHandler = async () => {
        // console.log(`check here: ${custIndividualEmail}`);
        //iscard=true;
        setProcessing(true);
        if (trxId === "demo") {
            await timeout(2000);
            const t = {
                ...trx,
                "status": demoResult || "success",
            };
            setTrx(t);
        } else {
            //console.log(custIndividualEmail);
            const result = await LPAPI.processCard(merchantId, trxId, cardInfo, trx.testMode, trx.currency, custIndividualEmail);
            //if (result.transactionid) {
            if (result.status.responsetype == "1" && result.status.statuscode == "0") {
                const t = { ...trx };
                t.status = "success";
                t.transactionid = result.transactionid;
                t.code = result.code;
                setTrx(t);
                if (result.redirect) {
                    setTimeout(() => {
                        window.location.href = result.redirect;
                    }, 1000);
                } else {
                    //console.log("subscribing to stream");
                    //const strm = DB.POSTrxStream(merchantId,trxId);
                }
                if (trx.trxRef !== "POS" && trx.trxRef !== "QR") {
                    let infos;
                    try {
                        infos = await DB.getPOSMerchInfo(merchantId, trxId);
                    } catch (e) {
                        alert(e.message);
                    }

                    const date = new Date();
                    const EmailReceipt = {
                        //amount: trx.amount,
                        amount: trx.amount.toFixed(2),
                        currency: trx.currency,
                        // transactiondate: date.getUTCDate() + "-" + date.getUTCMonth() + "-" + date.getUTCFullYear(),
                        transactiondate: result.transactiondate_utc,
                        transactionid: result.transactionid,
                        banktransactionnumber: result.billing.authresponse.banktransactionno,
                        cardno: result.billing.card.pan,
                        // customername:result.consumer.firstname.trim()+result.consumer.lastname.trim(),
                        // customeremail:result.consumer.email,
                        customername: infos.plName,
                        customeremail: infos.mail,
                        merchantemail: infos.plMerchantEmail,
                        merchantId: infos.merchantId,
                        gatewayreference: result.billing.authresponse.gatewayreference
                    }

                    // Adding custIndividualEmail property if it's not empty
                    if (custIndividualEmail !== "") {
                        EmailReceipt.custIndividualEmail = custIndividualEmail;
                    }

                    sentEmailReceipt(EmailReceipt);

                    if (custIndividualEmail != "") {
                        sentIndividualEmailReceipt(EmailReceipt);
                    }
                } else {
                    console.log("It's not a Paylink Transaction");
                    let infos;
                    try {
                        infos = await DB.getPOSMailInfo(merchantId);
                    } catch (e) {
                        // alert(e.message);
                        console.error(`Error here: ${e.message}`);
                    }

                    const date = new Date();
                    const isHolder = result.consumer.lastname.trim().toLowerCase() === "holder";
                    const customerName = result.consumer.firstname.trim() + (isHolder ? "" : " " + result.consumer.lastname.trim());

                    const EmailReceipt = {
                        //amount: trx.amount,
                        amount: trx.amount.toFixed(2),
                        currency: trx.currency,
                        // transactiondate: date.getUTCDate() + "-" + date.getUTCMonth() + "-" + date.getUTCFullYear(),
                        transactiondate: result.transactiondate_utc,
                        transactionid: result.transactionid,
                        banktransactionnumber: result.billing.authresponse.banktransactionno,
                        cardno: result.billing.card.pan,
                        // customername: result.consumer.firstname.trim() + " " + result.consumer.lastname.trim(),
                        customername: customerName,
                        customeremail: result.consumer.email,
                        merchantemail: infos,
                        merchantId: merchantId,
                        gatewayreference: result.billing.authresponse.gatewayreference
                    }
                    //sentEmailReceipt(EmailReceipt);

                    if (custIndividualEmail !== "") {
                        EmailReceipt.custIndividualEmail = custIndividualEmail;
                    }

                    sentEmailReceipt(EmailReceipt);

                    if (custIndividualEmail != "") {
                        sentIndividualEmailReceipt(EmailReceipt);
                    }
                }
                listenToStream(t);
            } else {
                const t = { ...trx };
                t.status = "error";
                try {
                    t.errorMsg = result.status.errordesc;
                } catch (e) {
                    t.errorMsg = null;
                }
                setTrx(t);
            }
        }
        setProcessing(false);
    }

    const groupByLocation = (inputArray) => {
        const gp = {};
        for (const item of inputArray) {
            if (!gp[item.info.loc]) { gp[item.info.loc] = []; }
            gp[item.info.loc].push({ name: item.name, qty: item.order.qty, status: item.order.status, loc: item.info.loc });
        }
        return gp;
    }

    const trxStatusByLoc = () => {
        const gp = groupByLocation(trx.order);
        const gl = [];
        for (const x in gp) gl.push(gp[x]);
        //return <>{gl.map((g) => <div key={g}>{g}</div>)}</>;
        //return gl.map((g) => <div key={JSON.stringify(g)}>{JSON.stringify(g)}</div>);
        return gl.map((g) => <>{/*<div style={{fontSize:"small"}}>
            {g[0].loc} 
            {g[0].status==="done" ? <FontAwesomeIcon style={{color: "#B7248F"}} icon={faCheck}/> :  <FontAwesomeIcon style={{color: "#CCCCCC"}} icon={faHourglass}/>}
    </div>*/}
            {g.map((item) => <div key={item.name}>{g[0].status === "done" ? <FontAwesomeIcon style={{ color: "#B7248F" }} icon={faCheck} /> : <FontAwesomeIcon style={{ color: "#CCCCCC" }} icon={faHourglass} />} {item.qty} x {item.name}</div>)}</>);
    }

    const showOrderInfo = () => {
        const qs = trx.table ? `t=${trx.table}` : (trx.name ? `n=${trx.name}` : "");
        return <>
            {/* <div className="text-center">
                <div style={{ fontSize: "small" }}>Order Code:</div>
            </div>
            <div className="payColor">
                <b className="fs-1">{trx.code}</b>
            </div> */}
            {/* <div className="my-2 text-start">
                {trxStatusByLoc()}
            </div> */}
            <div className="text-center">
                <div style={{ fontSize: "small" }}>Thank you</div>
            </div>
            <div className="payColor">
                <b className="fs-1">Success</b>
            </div>
            <div className="my-2 text-start">
                {trxStatusByLoc()}
            </div>
            {
                trx.status === "completed" ? <>
                    {/* <div className="mt-3">Your order has<br />been completed</div> */}
                    <div className="mt-3">Your Transaction has<br />been completed</div>
                    <div className="mt-1">
                        <FontAwesomeIcon className="fs-1" style={{ color: "#B7248F" }} icon={faCircleCheck} />
                    </div>
                    <div className="mt-3"><Link to={`/pos/${merchantId}?${qs}`}>Order Again</Link></div>
                </>
                    : <>
                        {/* <div className="mt-3">Please stay on this page<br/>for order updates!</div> */}
                        {/* <div className="mt-3">Your order has<br />been completed</div> */}
                        <div className="mt-3">Your Transaction has<br />been completed</div>
                    </>
            }
        </>
    }

    // lookup client
    // if no trxId, show all products
    // if trxId just show pay options

    useEffect(() => {
        const getInfo = async () => {
            const info = await DB.getPOSAccInfo(merchantId);
            //console.log(`info details: ${info}`);
            //setInvalid(!info);
            if (info) {
                setBrand(LatPayBrand.merchantBrand(info));
                info.live.paylinkPWD = info.live.paylinkPWD || "FpkU9F5Bw2";
                setMerchInfo(info);
                let trxInfo;
                if (trxId === "demo") {
                    setInvalidTrx(false);
                    trxInfo = {
                        amount: 1000.52,
                        status: "new",
                        testMode: true,
                        currency: "AUD",
                        date: "2022-09-02T05:19:21.977Z",
                        description: "Food Order",
                    };
                    setTrx(trxInfo);
                } else {
                    try {
                        trxInfo = await DB.getPOSTrx(merchantId, trxId);
                    } catch (e) {
                        alert(e.message);
                    }
                    setInvalidTrx(!trxInfo);
                    if (trxInfo) {
                        setTrx(trxInfo);
                        if (trxInfo.status === "paid") {
                            listenToStream(trxInfo);
                        }
                    }

                    const datas = {
                        merchantId: merchantId,
                        amount: `${trxInfo.amount.toFixed(2)}`,
                        currency: trxInfo.currency,
                        // reference: trxInfo.id,
                        reference: (trxInfo.clientRef !== undefined && trxInfo.clientRef !== null && trxInfo.clientRef !== "") ? trxInfo.clientRef : trxInfo.id,
                        testMode: trxInfo.testMode
                    }
                    getTransactionKey(datas);
                }
                if (trxInfo.testMode) {
                    setCardInfo({
                        name: "Latpay Demo",
                        card: "4200 0000 0000 0000",
                        exp: "12/27",
                        cvc: "123",
                    });
                }
            } else {
                console.log("Invalid merchant");
                setBrand(LatPayBrand.merchantBrand({}));
                setInvalidTrx(true);
            }
        }
        getInfo();
    }, []);

    //console.log(searchParams.get("x"));

    const copyRight = () => {
        return <div className="mt-4 text-light copyright" style={{ fontSize: "small" }}>
            <div>All Content Copyright &copy; 2026 Latpay</div>
            <div>
                <a
                    href="https://latpay.com/privacy-policy"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white text-decoration-none copyright-link"
                >
                    Privacy Policy
                </a>
                {" "}|{" "}
                {/* <Link className="text-light text-decoration-none" to="/">Privacy Policy</Link>{" "}|{" "} */}
                <a
                    href="https://latpay.com/terms-condition/"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-white text-decoration-none copyright-link"
                >
                    Terms &amp; Conditions
                </a>
                {/* <Link className="text-light text-decoration-none" to="/">Terms and Conditions</Link> */}
            </div>
        </div>;
    }

    const trxSheet = () => {

        //console.log(`merchInfo: ${JSON.stringify(merchInfo)}`);
        //console.log(`Trx Modes: ${JSON.stringify(trx)}`);




        runningAmount = parseFloat(trx.amount);
        // console.log(`runningAmt:` + runningAmount);

        if (showOrder) {

            return showOrderInfo();
        }
        switch (trx.status) {
            case "new":
                return <>
                    {/*<div className="p-2 mb-1">Pay to: {merchInfo.name}</div> */}
                    <div className="pb-2 mb-3 payColor">
                        {/*<span className="me-2">AUD</span>*/}
                        <span className="me-2">{trx.currency}</span>
                        {/*<b className="fs-1">{trx.amount.toFixed(2)}</b>*/}
                        <b className="fs-1">{utils.asAmount(trx.amount)}</b>
                    </div>

                    {processing ?
                        <div className="text-center">
                            <Spinner className="mx-auto my-3" animation="border" variant="dark" />
                            <h4>Processing</h4>
                        </div>
                        : <>
                            {trx.currency === "AUD" && merchInfo.test.paylinkPWD && <div>
                                <GooglePayButton
                                    //environment="TEST"
                                    environment="PRODUCTION"
                                    paymentRequest={googlePayInfo(trx)}
                                    onLoadPaymentData={async (paymentData) => {
                                        if (processing) return;
                                        setProcessing(true);
                                        try {
                                            //console.log(`merchInfo.live.paylinkPWD: ${merchInfo.live.paylinkPWD}`);
                                            //console.log('load payment data', paymentData);
                                            const token = JSON.parse(paymentData.paymentMethodData.tokenizationData.token)
                                            const signed = JSON.parse(token.signedMessage);

                                            const requestData = {
                                                token: token,
                                                type: paymentData.paymentMethodData.type,
                                                info: paymentData.paymentMethodData.info,
                                                currency: "AUD",
                                                amount: trx.amount.toFixed(2),
                                                // reference: trx.id,
                                                tRef: trx.id,
                                                reference: (trx.clientRef !== undefined && trx.clientRef !== null && trx.clientRef !== "") ? trx.clientRef : trx.id,
                                                description: trx.description,
                                                publickey: trx.testMode ? merchInfo.test.paylinkPWD : merchInfo.live.paylinkPWD,
                                                merchantId: trx.testMode ? merchInfo.test.paylinkMID : merchInfo.live.paylinkMID,
                                                transid: "0",
                                                source: "PayLink",
                                                // transid: trx.id,
                                                // source: trx.source,
                                                shippingAddress: paymentData.shippingAddress != null ? paymentData.shippingAddress : null,
                                                email: paymentData.email,
                                                otgMerchant: merchantId,
                                                transactionkey: transKey
                                            };
                                            requestData.token.signed = signed;
                                            // console.log("Recently hosted");
                                            // console.log(requestData);
                                            // now process
                                            const result = await LPAPI.processGooglePay(requestData);
                                            if (result.status.responsetype == "1" && result.status.statuscode == "0") {
                                                const t = { ...trx };
                                                t.status = "success";
                                                t.transactionid = result.transactionid;
                                                t.code = result.code;
                                                setTrx(t);
                                                if (result.redirect) {
                                                    setTimeout(() => {
                                                        window.location.href = result.redirect;
                                                    }, 1000);
                                                } else {
                                                    //console.log("subscribing to stream");
                                                    //const strm = DB.POSTrxStream(merchantId,trxId);
                                                }
                                                if (trx.trxRef !== "POS" && trx.trxRef !== "QR") {
                                                    let infos;
                                                    try {
                                                        infos = await DB.getPOSMerchInfo(merchantId, trxId);
                                                    } catch (e) {
                                                        alert(e.message);
                                                    }

                                                    const date = new Date();
                                                    const EmailReceipt = {
                                                        //amount: trx.amount,
                                                        amount: trx.amount.toFixed(2),
                                                        currency: trx.currency,
                                                        transactiondate: date.getUTCDate() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCFullYear(),
                                                        transactionid: result.authresponse.gatewayreference,
                                                        banktransactionnumber: result.authresponse.banktransactionno,
                                                        cardno: requestData.info.cardDetails,
                                                        // customeremail:requestData.email,
                                                        // customername:requestData.shippingAddress.name
                                                        merchantemail: infos.plMerchantEmail,
                                                        customeremail: infos.mail,
                                                        customername: infos.plName,
                                                        merchantId: infos.merchantId,
                                                    }
                                                    sentEmailReceipt(EmailReceipt);
                                                } else {
                                                    console.log("It's not a Paylink Transaction");
                                                    let infos;
                                                    try {
                                                        infos = await DB.getPOSMailInfo(merchantId);
                                                    } catch (e) {
                                                        // alert(e.message);
                                                        console.error(`Error here: ${e.message}`);
                                                    }

                                                    const date = new Date();
                                                    const EmailReceipt = {
                                                        //amount: trx.amount,
                                                        amount: trx.amount.toFixed(2),
                                                        currency: trx.currency,
                                                        transactiondate: date.getUTCDate() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCFullYear(),
                                                        transactionid: result.authresponse.gatewayreference,
                                                        banktransactionnumber: result.authresponse.banktransactionno,
                                                        cardno: requestData.info.cardDetails,
                                                        customeremail: requestData.email,
                                                        customername: requestData.shippingAddress.name,
                                                        merchantemail: infos,
                                                        merchantId: merchantId,
                                                    }
                                                    sentEmailReceipt(EmailReceipt);
                                                }
                                                listenToStream(t);
                                            } else {
                                                const t = { ...trx };
                                                t.status = "error";
                                                try {
                                                    t.errorMsg = result.status.errordesc;
                                                } catch (e) {
                                                    t.errorMsg = null;
                                                }
                                                setTrx(t);
                                            }
                                            //console.log("Google Pay Result", result);
                                        } catch (e) {

                                        }
                                        setProcessing(false);
                                    }}
                                />
                            </div>}

                            {/*merchInfo.publicKey && <div id="ckoApplePay" className="apple-pay-button apple-pay-button-text-buy" lang="en" onClick={payWithApple}></div>*/}
                            {trx.currency === "AUD" && merchInfo.test.paylinkPWD && <div id="ckoApplePay" className="apple-pay-button apple-pay-button-text-buy" lang="en" onClick={payWithApple}></div>}

                            {trx.currency === "AUD" && <div className="mt-2">- or pay by card -</div>}
                            {trx.currency != "AUD" && <div className="mt-2">Pay by Card</div>}
                            <div className="text-left mt-2">
                                <FloatingLabel label="Name on Card" className="mb-2">
                                    <Form.Control type="text" placeholder="Name" name={`name`} value={cardInfo.name} onChange={handleChange} />
                                </FloatingLabel>
                                <FloatingLabel label="Customer Email" className="mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="user@mail.com"
                                        name="email"
                                        value={custIndividualEmail}
                                        onChange={handleChange}
                                        isInvalid={emailError !== ''}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {emailError}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                                <FloatingLabel label="Card Number" className="mb-2">
                                    <Form.Control type="text" placeholder="1234 1234 1234 1234" name={`card`} value={cardInfo.card}
                                        //onChange={handleChange}
                                        onChange={(e) => {
                                            const cardNumber = e.target.value.replace(/\D/g, '').substring(0, 20);
                                            const formattedCardNumber = cardNumber.replace(/(.{4})/g, '$1 ').trim();
                                            setCardInfo(prevState => ({ ...prevState, card: formattedCardNumber }));
                                        }}
                                    />
                                </FloatingLabel>

                                <Row className="mb-2">
                                    <Col>
                                        <FloatingLabel label="Expiry">
                                            <Form.Control type="text" placeholder="MM/YY" name={`exp`} value={cardInfo.exp}
                                                //onChange={handleChange}
                                                onChange={(e) => {
                                                    const expiry = e.target.value.replace(/\D/g, '').substring(0, 5);
                                                    const formattedExpiry = expiry.replace(/(.{2})/, '$1/');
                                                    setCardInfo(prevState => ({ ...prevState, exp: formattedExpiry }));
                                                }}
                                            />
                                        </FloatingLabel>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="CVC">
                                            <Form.Control
                                                //type="text"
                                                type="password"
                                                placeholder="CVC" name={`cvc`} value={cardInfo.cvc}
                                                onChange={handleChange}
                                                maxLength="4"
                                            />
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                {(trx.testMode) ?
                                    <Button variant="warning" className="w-100 mt-2" onClick={payBtnHandler}>Test Pay Now</Button>
                                    //<Button variant="warning" className="w-100 mt-2" onClick={payBtnHandler}>Pay Now</Button>
                                    :
                                    <Button variant={brand.payBtn} className="w-100 mt-2" onClick={payBtnHandler}>Pay Now</Button>
                                }

                            </div>
                        </>}

                </>;
            case "success":
                //console.log(`Transaction Info: ${trx}`);

                if (trx.order) {
                    setTimeout(() => {
                        console.log("display status");
                        //console.log(trx.code);
                        setShowOrder(true);
                    }, 3000);
                }
                return <>
                    {/*<div className="p-2 mb-1">Pay to: {merchInfo.name}</div>*/}
                    <div className="payColor">
                        {/*<span className="me-2">AUD</span>*/}
                        <span className="me-2">{trx.currency}</span>
                        {/*<b className="fs-1">{trx.amount.toFixed(2)}</b>*/}
                        <b className="fs-1">{utils.asAmount(trx.amount)}</b>
                    </div>
                    <div className="text-center">
                        <Image src="/images/paysuccess.png" />
                    </div>
                    <div className="text-center mt-2">
                        <div>Payment successful!</div>
                        <div style={{ fontSize: "small" }}>Thank you, your payment is complete.</div>
                    </div>
                </>;
            case "error":
                return <>
                    {/*<div className="p-2 mb-1">Pay to: {merchInfo.name}</div>*/}
                    <div className="payColor">
                        {/*<span className="me-2">AUD</span>*/}
                        <span className="me-2">{trx.currency}</span>
                        {/*<b className="fs-1">{trx.amount.toFixed(2)}</b>*/}
                        <b className="fs-1">{utils.asAmount(trx.amount)}</b>
                    </div>
                    <div className="text-center">
                        <Image src="/images/payerror.png" />
                    </div>
                    <div className="text-center mt-2">
                        <h4>Oops!</h4>
                        <div>Payment Unsuccessful</div>
                        <div style={{ fontSize: "small" }}>Please select different payment method.</div>
                        <div className="mt-1" style={{ fontSize: "small" }}>
                            <Button variant={brand.payBtn} className="w-100 mt-2" onClick={tryAgain}>Try Again?</Button>
                        </div>
                    </div>
                </>;
            case "paid":
            case "completed":
                if (trx.order) return showOrderInfo();
                // if(iscard){
                //     if (trx.order) { return showOrderInfo(); }
                // }
                return <>
                    {/*<div className="p-2 mb-1">Pay to: {merchInfo.name}</div>*/}
                    <div className="pb-2 mb-3 payColor">
                        {/*<span className="me-2">AUD</span>*/}
                        <span className="me-2">{trx.currency}</span>
                        {/*<b className="fs-1">{trx.amount.toFixed(2)}</b>*/}
                        <b className="fs-1">{utils.asAmount(trx.amount)}</b>
                    </div>
                    <div className="text-center mt-2">
                        This transaction has been completed.
                    </div>
                </>;
            default:
                return <div className="p-2 mb-1">{trx.status}</div>
        }
    }

    const sentEmailReceipt = (receipt) => {
        //console.log("RECEIPT:" + JSON.stringify(receipt));
        // console.log('Beginning of sentEmailReceipt');

        var body;

        if (receipt.merchantId == "afaacademy") {
            body = {
                "from": `AcademyofFootballAustralia <${receipt.merchantId}@latpay.net>`,
                "to": [
                    `${receipt.customeremail}`
                ],
                // "cc": [
                //     "Mandy Froman <mandy@latpay.com>",
                //     "Support <dinesh@digisource.co.in>"
                // ],
                "bcc": [

                    `${receipt.merchantemail}`,
                    "Mandy Froman <mandy@latpay.com>",
                    "Dinesh <dinesh@digisource.co.in>"
                ],
                "test_mode": false,
                "subject": "Payment Receipt",
                "plain": "Please view with an HTML email client",
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with us.</p><hr><p><strong>TRANSACTION ID:</strong> ${receipt.transactionid} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>AFA</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "headers": {
                    "Reply-To": `${receipt.merchantId} <${receipt.merchantemail}>`
                }
            }
        }
        else {
            body = {
                "from": `${receipt.merchantId} <${receipt.merchantId}@latpay.net>`,
                "to": [
                    `${receipt.customeremail}`
                ],
                // "cc": [
                //     "Mandy Froman <mandy@latpay.com>",
                //     "Support <dinesh@digisource.co.in>"
                // ],
                "bcc": [
                    `${receipt.merchantemail}`,
                    "Mandy Froman <mandy@latpay.com>",
                    "Dinesh <dinesh@digisource.co.in>"
                ],
                "test_mode": false,
                "subject": "Payment Receipt",
                "plain": "Please view with an HTML email client",
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with us.</p><hr><p><strong>TRANSACTION ID:</strong> ${receipt.transactionid} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "headers": {
                    "Reply-To": `${receipt.merchantId} <${receipt.merchantemail}>`
                }
            }
        }


        fetch(`https://${latpayDomain}/api/sendReceipt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response from your Cloud Function
                // console.log('Cloud Function Response:', data);
            })
            .catch(error => {
                console.error('Error calling Cloud Function:', error);
            });
    }

    const sentIndividualEmailReceipt = (receipt) => {
        //console.log("RECEIPT:" + JSON.stringify(receipt));
        // console.log('Beginning of sentIndividualEmailReceipt');

        var body;

        if (receipt.merchantId == "afaacademy") {
            body = {
                "from": `AcademyofFootballAustralia <${receipt.merchantId}@latpay.net>`,
                "to": [
                    `${receipt.custIndividualEmail}`
                ],
                "bcc": [
                    "Dinesh <dinesh@digisource.co.in>"
                ],
                "test_mode": false,
                "subject": "Copy of Payment Receipt",
                "plain": "Please view with an HTML email client",
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with us.</p><hr><p><strong>TRANSACTION ID:</strong> ${receipt.transactionid} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>AFA</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
            }
        }
        else {
            body = {
                "from": `${receipt.merchantId} <${receipt.merchantId}@latpay.net>`,
                "to": [
                    `${receipt.custIndividualEmail}`
                ],
                "bcc": [
                    "Dinesh <dinesh@digisource.co.in>"
                ],
                "test_mode": false,
                "subject": "Copy of Payment Receipt",
                "plain": "Please view with an HTML email client",
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                //"html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h1>Latpay</h1><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with <b>${merchantId}</b></p><hr><p><strong>ORDER ID:</strong> ${trxId} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
                "html": `<!DOCTYPE html><html><head><style>  h1 {    font-style: italic;    color: #336699;  }  strong {    font-weight: bold;  }  hr {    border: none;    border-top: 1px dotted #ccc;    color: #ccc;    background-color: #ccc;    height: 1px;  }  .green-tick {    color: #00A600;    float: right;  }  table {    width: 100%;    border-collapse: collapse;  }  th, td {    border: 1px solid #ccc;    padding: 8px;    text-align: left;  }  .center-container {    margin: 0 25%;    text-align: left;  }  body {    background-color: #F5F5F5;  }  p {    color: #333;  }</style></head><body><div class=\"center-container\"><h3>Hi <strong>${receipt.customername}</strong>,</h3><p>Thank you for your recent purchase with us.</p><hr><p><strong>TRANSACTION ID:</strong> ${receipt.transactionid} <span class=\"green-tick\">&#10004; <strong>Paid</strong></span></p><hr><p>As per your instructions, the following transaction has been completed and will appear on your card statement with the details below:</p><table>  <tr>    <th>Transaction date:</th>    <td>${receipt.transactiondate}</td>  </tr>  <tr>    <th>Charge to your card is:</th>    <td>${receipt.amount}</td>  </tr> <tr>    <th>Card Statement Descriptor:</th>    <td>LAT*${merchantId}</td>  </tr>  <tr>    <th>Currency:</th>    <td>${receipt.currency}</td>  </tr>  <tr>    <th>Card Number:</th>    <td>${receipt.cardno}</td>  </tr>  <!--<tr>    <th>Gateway Reference:</th>    <td>${receipt.banktransactionnumber}</td>  </tr>-->  <tr>    <th>Bank Transaction number:</th>    <td>${receipt.transactionid}</td>  </tr>  <tr></table><p>If you have any queries or concerns regarding this transaction, please don’t hesitate to contact us. Our email address is: <a href=\"mailto:${receipt.merchantemail}\">${receipt.merchantemail}</a></p><p style=font-size:10px><strong>Note:</strong> Please include the transaction ID with your enquiry</p><p style=font-size:10px><strong>Legal Notice:</strong> This transaction has been processed by latpay, powered by Lateral Payment Solutions. Transactions passing through our gateway are covered under our Level 1, PCI Certification, the highest standard of data security measured by the Payment Card Industry. For further information, visit <a href=\"http://www.latpay.com.au\">www.latpay.com.au</a>. The information in this email is confidential and may be legally privileged. It is intended solely for the addressee and access to this email by anyone else is unauthorized. If you are not an addressee, you must not copy, distribute, disclose or use any of the information in it or on any attachments. If you have received it in error, please notify the sender and delete it immediately. Any views or opinions presented are solely those of the author and do not necessarily represent those of Lateral Payment Solutions Pty Ltd.</p></div></body></html>`,
            }
        }


        fetch(`https://${latpayDomain}/api/sendReceipt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response from your Cloud Function
                // console.log('Cloud Function Response:', data);
            })
            .catch(error => {
                console.error('Error calling Cloud Function:', error);
            });
    }

    const sentEmail = (receipt) => {
        //console.log("RECEIPT:" + JSON.stringify(receipt));
        //console.log('Beginning of sentEmail');

        var body = {
            "from": `dinesh@latpay.net`,
            "to": [
                `dinesh@digisource.co.in`,
                `jeyasheela@digisource.co.in`
            ],
            "test_mode": false,
            "subject": "Payment Receipt",
            "plain": "Please view with an HTML email client",
            "html": `<h3>${receipt.msg}</h3>`,
            "headers": {
                "Reply-To": `dinesh@latpay.net`
            }
        }

        fetch(`https://${latpayDomain}/api/sendReceipt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response from your Cloud Function
                //console.log('Cloud Function Response:', data);
            })
            .catch(error => {
                console.error('Error calling Cloud Function:', error);
            });
    }

    const sentEmail1 = (receipt) => {
        //console.log("RECEIPT:" + JSON.stringify(receipt));
        //console.log('Beginning of sentEmail');

        var body = {
            "from": `dinesh@latpay.net`,
            "to": [
                `dinesh@digisource.co.in`,
                `jeyasheela@digisource.co.in`
            ],
            "test_mode": false,
            "subject": "Payment Receipt",
            "plain": "Please view with an HTML email client",
            "html": `<h3>${receipt}</h3>`,
            "headers": {
                "Reply-To": `dinesh@latpay.net`
            }
        }

        fetch(`https://${latpayDomain}/api/sendReceipt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response from your Cloud Function
                //console.log('Cloud Function Response:', data);
            })
            .catch(error => {
                console.error('Error calling Cloud Function:', error);
            });
    }

    const getTransactionKey = async (requestData) => {
        const json = JSON.stringify(requestData);

        //console.log(`Get Transacion Key: ${json}`);

        const url = `https://${latpayDomain}/api/walletGetTransKey`;
        try {
            const response = await fetch(
                url,
                {
                    method: 'POST',
                    body: json,
                    //mode: 'cors',
                    headers: { 'Content-Type': 'application/json', }
                }
            );
            const result = await response.json();
            //console.log(`Result1: ${JSON.stringify(result)}`);
            if (result.status !== "00") {
                transKey = "";
                // console.log("Transkey NA");
            } else {
                transKey = `${result.result}`;
                // console.log("Transkey Available");
            }
            return result;
        } catch (e) {
            console.log(e.message);
            return { "error": e.message };
        }
    }

    //if (invalid) { return LatPayBrand.invalidMerchant(); }
    if (!brand) { return LatPayBrand.loadScreen(); }

    return (<>
        <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide animation style={{
            position: 'absolute',
            zIndex: 10000,
            top: 20,
            right: 20,
        }}>
            <Toast.Header>
                {/*<img
              src="holder.js/20x20?text=%20"
              className="rounded mr-2"
              alt=""
            />*/}
                <strong className="mr-auto">{notification.title}</strong>
                {/*<small>12 mins ago</small>*/}
            </Toast.Header>
            <Toast.Body>{notification.body}</Toast.Body>
        </Toast>
        <Container fluid className="py-5 pos d-flex aligns-items-center bg-gradient" style={{ backgroundColor: brand.bgColor }}>
            <div className="my-auto mx-auto">
                <Card className="shadow" style={{
                    backgroundColor: "#F8F8F8",
                    minWidth: "280px",
                    maxWidth: "360px",
                }}>

                    <div className="card-img-top p-2" style={{
                        backgroundColor: brand.bannerBg,

                    }}>
                        <div className="paytop" style={{
                            backgroundImage: `url(data:image/png;charset=utf-8;base64,${brand.logo})`,
                            textAlign: "right"
                            //backgroundImage: `url(/images/lat-pay-logo-300x135.png)`,
                            //}}>{!merchInfo.live.live && <Badge bg="warning" className="" style={{}}>TEST MODE</Badge>}</div> 
                        }}></div>
                    </div>
                    <div className="p-3">
                        {invalidTrx ? <div>
                            <h4>No such transaction</h4>
                            <p>We were unable to retrieve a payment request related to this transaction reference.</p>
                            <p>Ref: {trxId}</p>
                        </div> :
                            <>{trx ? trxSheet() : <div>
                                <Spinner animation="border" />
                            </div>}</>
                        }
                    </div>
                </Card>
                {copyRight()}
            </div>
        </Container>
        <PayFooter />
    </>
    );



}

export default POSPay;